document.addEventListener('DOMContentLoaded', function () {
  /* Shared utility */
  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- Announcement Bar Dismiss ---------- */
  var announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    var dismissBtn = announcement.querySelector('[data-announcement-dismiss]');
    var key = 'announcement-dismissed';
    var content = announcement.textContent.trim();
    var stored = null;
    try { stored = localStorage.getItem(key); } catch (e) {}
    // Hide if previously dismissed for the SAME content (changing the message re-shows it)
    if (stored && stored === simpleHash(content)) {
      announcement.style.display = 'none';
    }
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        announcement.style.display = 'none';
        try { localStorage.setItem(key, simpleHash(content)); } catch (e) {}
      });
    }
  }
  function simpleHash(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) - h) + str.charCodeAt(i);
      h |= 0;
    }
    return String(h);
  }

  /* ---------- Sticky Mobile ATC Bar ---------- */
  // Shown whenever the main Add to Cart row is off screen (above OR below), so
  // a phone visitor always has a buy button: on load the main button sits
  // ~1300px down, below the first screen. Hidden while the main row is visible.
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  if (stickyAtc) {
    var mainAtc = document.querySelector('.atc-row');
    if (mainAtc) {
      var setShow = function (show) {
        stickyAtc.classList.toggle('is-visible', show);
        stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          setShow(!entries[0].isIntersecting);
        }).observe(mainAtc);
      } else {
        var update = function () {
          var rect = mainAtc.getBoundingClientRect();
          setShow(rect.bottom < 0 || rect.top > window.innerHeight);
        };
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      }
    }
  }

  /* ---------- Smooth Hover Prefetch (subtle perf win on internal links) ---------- */
  var prefetched = new Set();
  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest('a[href^="/"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.indexOf('/cart') === 0 || href.indexOf('/checkout') === 0 || href.indexOf('#') === 0) return;
    if (prefetched.has(href)) return;
    prefetched.add(href);
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  });

  /* ---------- View Transitions API (progressive enhancement) ---------- */
  // Wraps all internal navigation in view transitions when supported.
  if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (link.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (link.hasAttribute('data-cart-open') || link.closest('[data-cart-close]')) return;
      e.preventDefault();
      document.startViewTransition(function () {
        return new Promise(function (resolve) {
          window.location.href = href;
          // resolve never gets called because navigation occurs; that's fine
          setTimeout(resolve, 1000);
        });
      });
    });
  }

  /* ---------- Mobile Menu Toggle ---------- */
  var menuToggle = document.querySelector('.header-menu-toggle');
  var mainNav = document.querySelector('nav.main-nav');
  if (menuToggle && mainNav) {
    menuToggle.setAttribute('aria-expanded', 'false');
    if (!mainNav.id) mainNav.id = 'MainNav';
    menuToggle.setAttribute('aria-controls', mainNav.id);

    var setExpanded = function (open) {
      mainNav.classList.toggle('active', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    menuToggle.addEventListener('click', function () {
      setExpanded(!mainNav.classList.contains('active'));
    });
    mainNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setExpanded(false); });
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.header-right') && !event.target.closest('nav.main-nav')) {
        setExpanded(false);
      }
    });
  }

  /* ---------- Quantity Stepper ---------- */
  document.querySelectorAll('.qty button').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = this.parentElement.querySelector('input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (button.textContent.trim() === '+') input.value = val + 1;
      else if (button.textContent.trim() === '-' && val > 1) input.value = val - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Product Gallery Thumbnails ---------- */
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      var mainImg = document.querySelector('.gallery-main img');
      if (mainImg && this.dataset.full) mainImg.src = this.dataset.full;
    });
  });
  if (thumbs.length > 0) thumbs[0].classList.add('active');

  /* Parts Finder is registered at the bottom of this file, OUTSIDE the
     DOMContentLoaded wrapper, so the submit handler is bound regardless of
     when theme.js loads. */

  /* ---------- Header Search + Predictive ---------- */
  var searchToggle = document.querySelector('.header-search-toggle');
  var searchPanel = document.getElementById('HeaderSearch');
  if (searchToggle && searchPanel) {
    var searchInput = searchPanel.querySelector('[data-predictive-search]');
    var searchResults = searchPanel.querySelector('[data-predictive-results]');

    var setSearchOpen = function (open) {
      searchPanel.classList.toggle('is-open', open);
      searchPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && searchInput) {
        setTimeout(function () { searchInput.focus(); }, 50);
      }
    };
    searchToggle.addEventListener('click', function () {
      setSearchOpen(!searchPanel.classList.contains('is-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) setSearchOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!searchPanel.classList.contains('is-open')) return;
      if (e.target.closest('.header-search') || e.target.closest('.header-search-toggle')) return;
      setSearchOpen(false);
    });

    // Predictive search via Shopify's /search/suggest.json
    var debounce;
    var renderResults = function (data) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        searchResults.innerHTML = '<div class="header-search__empty">No matches yet. Press Enter to search the full catalog.</div>';
        searchResults.removeAttribute('hidden');
        return;
      }
      var html = '<ul class="header-search__list">';
      products.slice(0, 6).forEach(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy" width="48" height="48">'
          : '<div class="header-search__placeholder">CC</div>';
        var price = p.price ? '<span class="header-search__price">' + p.price + '</span>' : '';
        html += '<li><a href="' + p.url + '">' + img +
          '<div class="header-search__item-info">' +
            '<span class="header-search__title">' + escapeHtml(p.title) + '</span>' +
            price +
          '</div></a></li>';
      });
      html += '</ul>';
      var inputVal = searchInput.value.trim();
      if (inputVal) {
        html += '<a href="/search?q=' + encodeURIComponent(inputVal) + '&type=product" class="header-search__view-all">View all results for "' + escapeHtml(inputVal) + '"</a>';
      }
      searchResults.innerHTML = html;
      searchResults.removeAttribute('hidden');
    };

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(debounce);
        var q = searchInput.value.trim();
        if (q.length < 2) {
          searchResults.setAttribute('hidden', '');
          searchResults.innerHTML = '';
          return;
        }
        debounce = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
            { credentials: 'include' })
            .then(function (r) { return r.json(); })
            .then(renderResults)
            .catch(function () { /* silent */ });
        }, 180);
      });
    }
  }

  /* ---------- Mini-Cart Drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  if (drawer) {
    var formatMoney = function (cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    var openDrawer = function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    };

    // Open via cart icon (desktop + mobile)
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        // Allow modified clicks (cmd-click, middle-click) to navigate normally
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        openDrawer();
      });
    });

    // Close via backdrop or X
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeDrawer(); });
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Render cart from /cart.js JSON
    var renderCart = function (cart) {
      var body = drawer.querySelector('[data-cart-body]');
      var footer = drawer.querySelector('[data-cart-footer]');
      var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
      var countEls = document.querySelectorAll('[data-cart-count]');

      // Update count badges (header + drawer)
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p>' +
          '<a href="/collections/all" class="btn-red" data-cart-close>Shop All Parts</a></div>';
        if (footer) footer.setAttribute('hidden', '');
      } else {
        var html = '<ul class="cart-drawer__items" data-cart-items>';
        cart.items.forEach(function (item) {
          var img = item.image ? '<a href="' + item.url + '" class="cart-drawer__item-img">' +
            '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="60" height="60"></a>' : '';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ?
            '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
          html += '<li class="cart-drawer__item" data-cart-item data-key="' + item.key + '">' +
            img +
            '<div class="cart-drawer__item-info">' +
              '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
              variant +
              '<div class="cart-drawer__item-row">' +
                '<span class="cart-drawer__item-qty">Qty ' + item.quantity + '</span>' +
                '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button class="cart-drawer__remove" type="button" data-cart-remove="' + item.key + '">Remove</button>' +
            '</div></li>';
        });
        html += '</ul>';
        body.innerHTML = html;
        if (footer) footer.removeAttribute('hidden');
      }
      // Re-bind close buttons on freshly rendered "Shop All Parts" / etc.
      drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
        if (el.dataset.cartCloseBound) return;
        el.dataset.cartCloseBound = '1';
        el.addEventListener('click', function () { closeDrawer(); });
      });
      // Bind remove buttons
      drawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeLine(btn.dataset.cartRemove);
        });
      });
    };

    var fetchCart = function () {
      return fetch('/cart.js', { credentials: 'include' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); return cart; });
    };

    var removeLine = function (key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
    };

    // Bind initial remove buttons (server-rendered)
    drawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeLine(btn.dataset.cartRemove);
      });
    });

    // Intercept ATC form submissions on product pages
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('button[type="submit"], .atc-btn');
        var originalLabel = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'include',
          body: formData
        }).then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        }).then(function () {
          return fetchCart();
        }).then(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel; }
          openDrawer();
        }).catch(function (err) {
          console.error(err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel; }
          // Fall back to form submission so the user still gets an outcome
          form.removeEventListener('submit', arguments.callee);
          form.submit();
        });
      });
    });
  }
});

/* ============================================================
   PARTS FINDER (top-level, timing-independent)
   ============================================================ */
(function () {
  var yearToCollection = {
    '1980-1997': '/collections/1980-1997-ford-cummins-transmission-adapters',
    '1999-2002': '/collections/1999-2000-ford-cummins-transmission-adapters',
    '2003-2007': '/collections/2003-2007-ford-cummins-transmission-adapters',
    '2008-2010': '/collections/2008-2010-ford-cummins-transmission-adapters',
    '2011-2016': '/collections/ford-cummins-conversion-kits',
    '2017-2019': '/collections/ford-cummins-conversion-kits',
  };
  var yearToLanding = {
    '1980-1997': '/pages/1980-1997-ford-cummins-swap',
    '1999-2002': '/pages/1999-2002-ford-cummins-swap',
    '2003-2007': '/pages/2003-2007-ford-cummins-swap',
    '2008-2010': '/pages/2008-2010-ford-cummins-swap',
  };
  function engineFamily(val) {
    if (!val) return null;
    if (val.indexOf('Common Rail') !== -1) return 'CR';
    if (val.indexOf('6.7L Cummins') !== -1) return 'CR';
    if (val.indexOf('12V') !== -1 || val.indexOf('24V') !== -1) return '1224';
    if (val.indexOf('4BT') !== -1) return '4BT';
    return null;
  }
  function transFamily(val) {
    if (!val) return null;
    if (val.indexOf('5R110') !== -1) return '5R110';
    if (val.indexOf('ZF6') !== -1) return 'ZF6';
    if (val.indexOf('48RE') !== -1) return '48RE';
    if (val.indexOf('NV4500') !== -1 || val.indexOf('NV5600') !== -1) return 'NV';
    return null;
  }
  var fullKitMap = {
    '2003-2007|CR|5R110':    '/products/2003-2007-f250-f550-excursion-to-2003-2020-cr-cummins-with-5r-transmission-kit',
    '2003-2007|CR|ZF6':      '/products/2003-2007-f250-f550-excursion-to-2003-2020-cr-cummins-with-zf6-transmission-kit',
    '2003-2007|1224|5R110':  '/products/2003-2007-f250-f550-excursion-to-1989-2002-12-24v-cummins-with-5r-transmission-kit',
    '2003-2007|1224|ZF6':    '/products/2003-2007-f250-f550-excursion-to-1989-2002-12-24v-cummins-with-zf6-transmission-kit',
    '2008-2010|CR|5R110':    '/products/2008-2010-f250-f550-to-2003-2020-cr-cummins-with-5r-transmission-kit',
    '2008-2010|CR|ZF6':      '/products/2008-2010-f250-f550-to-2003-2020-cr-cummins-with-zf6-transmission-kit',
    '2008-2010|1224|5R110':  '/products/2008-2010-f250-f550-to-1989-2002-12-24v-cummins-with-5r-transmission-kit',
    '2008-2010|1224|ZF6':    '/products/2008-2010-f250-f550-to-1989-2002-12-24v-cummins-with-zf6-transmission-kit',
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'parts-finder-form') return;
    e.preventDefault();

    var yearEl = document.getElementById('truck-year');
    var engineEl = document.getElementById('truck-engine');
    var transEl = document.getElementById('truck-transmission');
    var year = yearEl ? yearEl.value : '';
    var engine = engineEl ? engineEl.value : '';
    var trans = transEl ? transEl.value : '';

    if (!year) {
      window.location.href = '/collections/ford-cummins-conversion-kits';
      return;
    }

    var ef = engineFamily(engine);
    var tf = transFamily(trans);

    var kitKey = year + '|' + ef + '|' + tf;
    if (fullKitMap[kitKey]) {
      window.location.href = fullKitMap[kitKey];
      return;
    }

    if (yearToLanding[year] && (ef || tf)) {
      window.location.href = yearToLanding[year];
      return;
    }

    if (yearToCollection[year]) {
      window.location.href = yearToCollection[year];
      return;
    }

    window.location.href = '/collections/ford-cummins-conversion-kits';
  });
})();
